module.exports = __webpack_public_path__ + "static/media/mail.d238b902.svg";